module.exports = __webpack_public_path__ + "img/placeholder_UBlog.cf146df4.jpg";